(function () {
  const initTabs = () => {
    document.querySelectorAll('[data-tabs]').forEach((root) => {
      const buttons = Array.from(root.querySelectorAll('[data-tab-button]'));
      const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));
      if (buttons.length === 0 || panels.length === 0) return;

      const defaultIndex = Math.max(
        0,
        Math.min(buttons.length - 1, parseInt(root.getAttribute('data-default-index'), 10) || 0)
      );

      const setActive = (index) => {
        const activeIndex = Math.max(0, Math.min(buttons.length - 1, index));

        buttons.forEach((btn, i) => {
          const isActive = i === activeIndex;
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          btn.setAttribute('tabindex', isActive ? '0' : '-1');
          btn.classList.toggle('border-primary', isActive);
          btn.classList.toggle('text-gray-900', isActive);
          btn.classList.toggle('shadow-md', isActive);
          btn.classList.toggle('bg-white', isActive);
          btn.classList.toggle('text-gray-600', !isActive);
          btn.classList.toggle('bg-white/90', !isActive);
        });

        panels.forEach((panel, i) => {
          panel.toggleAttribute('hidden', i !== activeIndex);
        });
      };

      buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => setActive(i));
        btn.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            const next = (i + 1) % buttons.length;
            setActive(next);
            buttons[next].focus();
          }

          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            const prev = (i - 1 + buttons.length) % buttons.length;
            setActive(prev);
            buttons[prev].focus();
          }
        });
      });

      setActive(defaultIndex);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();
